import { useState } from 'react'
import { Dialog, VisuallyHidden, Inset } from '@radix-ui/themes'
import { styles } from './styles.css'
import close from './images/close.svg'

type Props = {
  title: string
  renderTrigger: () => React.ReactNode
  renderContent?: () => React.ReactNode
}

export const Modal: React.FC<Props> = ({ title, renderTrigger, renderContent }) => {
  const [showCloseButton, setShowCloseButton] = useState(false)

  return (
    <Dialog.Root onOpenChange={(isOpen) => setShowCloseButton(isOpen)}>
      <Dialog.Trigger>{renderTrigger()}</Dialog.Trigger>
      <Dialog.Content className={styles.content} height="calc(100dvh - 164px)" maxWidth="500px" aria-describedby={undefined}>
        <VisuallyHidden>
          <Dialog.Title>{title}</Dialog.Title>
        </VisuallyHidden>
        <Inset side="all">{renderContent()}</Inset>
      </Dialog.Content>
      {showCloseButton && (
        <div className={styles.close}>
          <Dialog.Trigger>
            <img src={close} />
          </Dialog.Trigger>
        </div>
      )}
    </Dialog.Root>
  )
}
